<template>
  <div class="editable-star-rating">
    <div class="stars-container">
      <button
        v-for="star in 5"
        :key="star"
        class="star-button"
        :class="{ 'active': star <= currentRating, 'hover': star <= hoverRating }"
        @click="setRating(star)"
        @mouseenter="hoverRating = star"
        @mouseleave="hoverRating = 0"
        :disabled="disabled"
      >
        {{ star <= (hoverRating || currentRating) ? '★' : '☆' }}
      </button>
    </div>
    <span v-if="showCount" class="rating-count">{{ currentRating }}/5</span>
  </div>
</template>

<script>
export default {
  name: 'EditableStarRating',
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hoverRating: 0
    };
  },
  computed: {
    currentRating() {
      return this.modelValue || 0;
    }
  },
  methods: {
    setRating(rating) {
      if (!this.disabled) {
        this.$emit('update:modelValue', rating);
      }
    }
  }
};
</script>

<style scoped>
.editable-star-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stars-container {
  display: flex;
  gap: 0.25rem;
}

.star-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #D1D5DB;
  transition: all 0.2s ease;
  line-height: 1;
}

.star-button:not(:disabled):hover {
  transform: scale(1.1);
}

.star-button.active,
.star-button.hover {
  color: #F59E0B;
}

.star-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.rating-count {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6B7280;
  min-width: 35px;
}
</style>
